import { Component } from '@angular/core'
import { OrganizationService, SiteMembershipService } from '@se-po/shared-data-access-services'
import { merge, Observable, of } from 'rxjs'
import { catchError, first, map, startWith, switchMap, tap } from 'rxjs/operators'

export const OPEN_REGISTRATION_FEATURE_TOGGLE_KEY = 'open_registration'

@Component({
  selector: 'app-registration-list-route',
  templateUrl: './registration-list-route.component.html',
  styleUrls: ['./registration-list-route.component.scss']
})
export class RegistrationListRouteComponent {
  public organizationIds: number[] = []
  public showOpenRegistration$: Observable<boolean | null>

  constructor(
    private organizationService: OrganizationService,
    private siteMembershipService: SiteMembershipService
  ) {
    this.showOpenRegistration$ = this.getOrganizationIds().pipe(
      switchMap(organizationIds => {
        if (!organizationIds.length) return of(false)

        return merge(...organizationIds.map(organizationId =>
              this.organizationService.hasFeatureToggleEnabled(
                organizationId.toString(),
                OPEN_REGISTRATION_FEATURE_TOGGLE_KEY
              ).pipe(
                catchError(() => of(false))
              )
            )
          ).pipe(
            first(result => result === true, false),
          )
      }),
      catchError(() => of(false)),
      startWith(null)
    )
  }

  private getOrganizationIds(): Observable<number[]> {
    return this.siteMembershipService.mine().pipe(
      map(siteMemberships => [...new Set(siteMemberships.map(siteMembership => siteMembership.organization_id))]),
      tap(organizationIds => this.organizationIds = organizationIds)
    )
  }
}
